<template>
  <label class="block text-sm font-medium leading-6"
    >{{ modelName }}
    <div class="h-48 overflow-y-scroll rounded border border-[#e05454]">
      <div class="relative my-2 block w-full">
        <MagnifyingGlassIcon
          class="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-[#ccd1c4]"
          aria-hidden="true"
        />
        <input
          id="search-field"
          ref="input"
          class="block h-full w-full border-0 bg-background py-0 pl-8 pr-0 text-white focus:outline-none focus:ring-0 sm:text-sm"
          placeholder="Search..."
          type="search"
          v-model="search"
        />
      </div>
      <div class="divide-y divide-[#ccd1c4] border-b border-t border-[#e05454]">
        <div v-for="obj in filterData" class="relative py-2">
          <label class="flex select-none font-medium">
            <div class="min-w-0 flex-1 text-sm leading-6">
              {{ obj[modelType] }}
              <template v-if="secondaryType && obj[secondaryType]">({{ obj[secondaryType] }})</template>
            </div>
            <div class="ml-3 flex h-6 items-center px-2">
              <input
                :id="obj.ID"
                :name="modelName"
                :value="obj"
                type="checkbox"
                v-model="selectedObjects"
                class="h-4 w-4 rounded text-[#e05454] accent-[#e05454] focus:ring-[#e05454]"
                :disabled="elementDisabledFn != null && elementDisabledFn(obj)"
                :title="elementTitleFn != null && elementTitleFn(obj)"
              />
            </div>
          </label>
        </div>
      </div>
    </div>
  </label>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { MagnifyingGlassIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
  modelValue: {
    required: true,
  },
  modelName: {
    required: true,
  },
  modelType: {
    required: true,
  },
  modelSelected: {
    required: false,
  },
  secondaryType: {
    required: false,
  },
  elementDisabledFn: {
    type: Function,
    required: false,
    default: null,
  },
  elementTitleFn: {
    type: Function,
    required: false,
    default: null,
  },
});

const emit = defineEmits(["update:modelValue"]);

const search = ref("");

const selectedObjects = ref(props.modelSelected);

const filterData = computed(() => {
  if (!search.value) return props.modelValue;
  return props.modelValue.filter((item) => item[props.modelType].toLowerCase().includes(search.value.toLowerCase()));
});

watch(selectedObjects, async (newSelected, oldSelected) => {
  emit("update:modelValue", selectedObjects.value);
});
</script>
